<template>
  <div class="home">
    <HeroBanner />
    
    <div class="main-content">
      <h2 class="section-title">Claritone科睿通 &reg; 一站式医学AI科研平台</h2>
      
      <!-- 加载中 -->
      <div v-if="loading" class="loading-state">
        <div class="loading-spinner"></div>
        <p>正在加载...</p>
      </div>
      
      <!-- 加载失败 -->
      <div v-else-if="loadError" class="error-state">
        <p>{{ errorMessage || '数据加载失败，请稍后重试' }}</p>
        <button class="retry-btn" @click="fetchData">重新加载</button>
      </div>
      
      <!-- 数据为空 -->
      <div v-else-if="sections.length === 0" class="empty-state">
        <p>暂无数据</p>
      </div>
      
      <!-- 分类列表 -->
      <ToolSection
        v-for="(section, index) in sections"
        :key="section.id"
        :title="section.title"
        :tools="section.tools"
        :columns="section.columns"
        v-else
      />
    </div>
  </div>
</template>

<script>
import HeroBanner from '../components/HeroBanner.vue'
import ToolSection from '../components/ToolSection.vue'
import { getCategoryList } from '../api/task'

// 工具名称 → 路由 tool 参数 映射表
 

// 各分类主题色
const SECTION_COLORS = [
  ['#f8f7fd', '#6c4eff'],  // 第1个分类
  ['#f8f7fd', '#6c4eff'],  // 第2个分类
  ['#f8f7fd', '#6c4eff'],  // 第3个分类
  ['#f8f7fd', '#6c4eff']   // 第4个分类
]

// 给工具分配图标颜色（同一分类内交替两种颜色）
export function getToolIconColor(sectionIndex, toolIndex) {
  // const colors = SECTION_COLORS[sectionIndex % SECTION_COLORS.length]
  return "#f8f7fd";
} 

// 将 API 返回的分类列表转为页面需要的 sections 格式
export function transformCategories(categories) {
  return categories.map((cat, sectionIdx) => ({
    id: cat.id,
    title: cat.name,
    columns: 3,
    tools: (cat.taskList || []).map((task, toolIdx) => {
      let description = task.intro || ''
      // 在 AI写作工作台下，追加说明文字
      if (cat.name && cat.name.includes('AI写作工作台')) {
        description += '\n* 通过电脑使用'
      }
      return {
        id: task.id,
        title: task.name,
        description: description,
        iconColor: getToolIconColor(sectionIdx, toolIdx),
        link: '/chat?tool=' + task.toolName + '&taskId=' + task.id,
      }
    })
  }))
}

export default {
  name: 'Home',
  components: {
    HeroBanner,
    ToolSection
  },
  data() {
    return {
      sections: [],
      loading: true,
      loadError: false,
      errorMessage: ''
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      this.loadError = false
      try {
        const pageResult = await getCategoryList({ page: 1, pageSize: 50 })
        console.log('分类数据:', pageResult)
        const records = pageResult.records || []
        this.sections = transformCategories(records)
      } catch (err) {
        console.error('加载分类数据失败:', err)
        this.loadError = true
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.home {
  width: 100%;
  min-height: 100vh;
  background: #f5f7fa;
}

.main-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 60px 20px;
}

.section-title {
  text-align: center;
  font-size: 36px;
  font-weight: bold;
  color: #1a1a2e;
  margin-bottom: 50px;
}

@media (max-width: 768px) {
  .main-content {
    padding: 40px 15px;
  }
  
  .section-title {
    font-size: 28px;
    margin-bottom: 30px;
  }
}
</style>
